import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {AccreditationBody, EstimateQuestion, StandardName} from "../../store/state/order.state";
import {EstimateQuestionsFetchService} from "./estimate-questions-fetch.service";

@Injectable()
export class EstimateQuestionsResolver implements Resolve<Observable<StandardEstimateQuestions[]>> {

	constructor(private fetchService: EstimateQuestionsFetchService) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<StandardEstimateQuestions[]> {
		return this.fetchService.fetchEstimateQuestions();
	}
}

export type EstimateQuestionsForAccBody = { [accreditationBody: string]: StandardEstimateQuestions[] };

export interface StandardEstimateQuestions {
	standardName: StandardName;
	questions: EstimateQuestion[];
	accreditationBody: AccreditationBody;
}

export function prepareIso27701Questions(iso27701questions: EstimateQuestion[], iso27001questions: EstimateQuestion[]) {
	return iso27001questions.concat(iso27701questions);
}

export function filterIso27701Questions(questions: EstimateQuestion[]): EstimateQuestion[] {
	return questions.filter(q => q.questionId == 'CONTROLLER_OR_PROCESSOR' || q.questionId == 'SIMULTANEOUSLY_WITH_ISO_27001');
}
